<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-missilefacilities-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 510}
    <div id="g-missilefacilities-xs" class="g-artboard" style="">
      <div style="padding: 0 0 112.1212% 0;"></div>
      <div
        id="g-missilefacilities-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/missilefacilities-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-text g-aiAbs g-aiPointText"
        style="top:5.0331%;margin-top:-10.6px;left:5.796%;width:148px;"
      >
        <p class="g-pstyle0">Iran missile facilities</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-text g-aiAbs g-aiPointText"
        style="top:5.0331%;margin-top:-10.6px;left:52.6777%;width:176px;"
      >
        <p class="g-pstyle0">Israel strikes (June 12-16)</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-text g-aiAbs g-aiPointText"
        style="top:25.3937%;margin-top:-6px;left:7.2002%;width:61px;"
      >
        <p class="g-pstyle1">TURKEY</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-text g-aiAbs g-aiPointText"
        style="top:38.6706%;margin-top:-6.1px;left:64.9759%;width:62px;"
      >
        <p class="g-pstyle2">Tehran</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-text g-aiAbs g-aiPointText"
        style="top:39.1774%;margin-top:-6px;left:15.1386%;width:51px;"
      >
        <p class="g-pstyle1">SYRIA</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-text g-aiAbs g-aiPointText"
        style="top:39.1774%;margin-top:-6px;left:30.5595%;width:46px;"
      >
        <p class="g-pstyle1">IRAQ</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-text g-aiAbs g-aiPointText"
        style="top:45.1346%;margin-top:-6px;left:21.5911%;width:61px;"
      >
        <p class="g-pstyle3">950 km</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-text g-aiAbs g-aiPointText"
        style="top:54.6165%;margin-top:-6.1px;left:70.7972%;width:55px;"
      >
        <p class="g-pstyle4">IRAN</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-text g-aiAbs g-aiPointText"
        style="top:54.6165%;margin-top:-6.1px;left:10.0874%;width:68px;"
      >
        <p class="g-pstyle5">ISRAEL</p>
      </div>
      <div
        id="g-ai0-10"
        class="g-text g-aiAbs g-aiPointText"
        style="top:74.0423%;margin-top:-6px;left:24.003%;width:92px;"
      >
        <p class="g-pstyle1">SAUDI ARABIA</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: sm -->
  {#if width && width >= 510 && width < 660}
    <div id="g-missilefacilities-sm" class="g-artboard" style="">
      <div style="padding: 0 0 84.3137% 0;"></div>
      <div
        id="g-missilefacilities-sm-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/missilefacilities-sm.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-text g-aiAbs g-aiPointText"
        style="top:4.3308%;margin-top:-10.6px;left:4.3273%;width:148px;"
      >
        <p class="g-pstyle0">Iran missile facilities</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-text g-aiAbs g-aiPointText"
        style="top:4.3308%;margin-top:-10.6px;left:40.1287%;width:176px;"
      >
        <p class="g-pstyle0">Israel strikes (June 12-16)</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-text g-aiAbs g-aiPointText"
        style="top:15.2514%;margin-top:-8.6px;left:45.9622%;width:65px;"
      >
        <p class="g-pstyle1">Amand</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-text g-aiAbs g-aiPointText"
        style="top:20.6002%;margin-top:-8.6px;left:14.3573%;width:72px;"
      >
        <p class="g-pstyle2">TURKEY</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-text g-aiAbs g-aiPointText"
        style="top:26.6468%;margin-top:-8.6px;left:46.3201%;width:57px;"
      >
        <p class="g-pstyle1">Tabriz</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-text g-aiAbs g-aiPointText"
        style="top:37.8095%;margin-top:-8.6px;left:19.0395%;width:59px;"
      >
        <p class="g-pstyle2">SYRIA</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-text g-aiAbs g-aiPointText"
        style="top:37.8095%;margin-top:-8.6px;left:33.5878%;width:53px;"
      >
        <p class="g-pstyle2">IRAQ</p>
      </div>
      <div
        id="g-ai1-8"
        class="g-text g-aiAbs g-aiPointText"
        style="top:38.0421%;margin-top:-8.6px;left:65.3981%;width:62px;"
      >
        <p class="g-pstyle3">Tehran</p>
      </div>
      <div
        id="g-ai1-9"
        class="g-text g-aiAbs g-aiPointText"
        style="top:46.4239%;margin-top:-8.6px;left:0.6578%;width:71px;"
      >
        <p class="g-pstyle4">ISRAEL</p>
      </div>
      <div
        id="g-ai1-10"
        class="g-text g-aiAbs g-aiPointText"
        style="top:46.4239%;margin-top:-8.6px;left:70.9999%;width:57px;"
      >
        <p class="g-pstyle5">IRAN</p>
      </div>
      <div
        id="g-ai1-11"
        class="g-text g-aiAbs g-aiPointText"
        style="top:51.763%;margin-top:-8.6px;left:30.1463%;margin-left:-33.5px;width:67px;"
      >
        <p class="g-pstyle6">950 km</p>
      </div>
      <div
        id="g-ai1-12"
        class="g-text g-aiAbs g-aiPointText"
        style="top:77.3444%;margin-top:-8.6px;left:30.2434%;width:111px;"
      >
        <p class="g-pstyle2">SAUDI ARABIA</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660}
    <div id="g-missilefacilities-md" class="g-artboard" style="">
      <div style="padding: 0 0 72.7273% 0;"></div>
      <div
        id="g-missilefacilities-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/missilefacilities-md.jpg);"
      ></div>
      <div
        id="g-ai2-1"
        class="g-text g-aiAbs g-aiPointText"
        style="top:3.68%;margin-top:-10.7px;left:3.6691%;width:157px;"
      >
        <p class="g-pstyle0">Iran missile facilities</p>
      </div>
      <div
        id="g-ai2-2"
        class="g-text g-aiAbs g-aiPointText"
        style="top:3.68%;margin-top:-10.7px;left:31.3339%;width:186px;"
      >
        <p class="g-pstyle0">Israel strikes (June 12-16)</p>
      </div>
      <div
        id="g-ai2-3"
        class="g-text g-aiAbs g-aiPointText"
        style="top:13.3502%;margin-top:-9.1px;left:46.5388%;width:65px;"
      >
        <p class="g-pstyle1">Amand</p>
      </div>
      <div
        id="g-ai2-4"
        class="g-text g-aiAbs g-aiPointText"
        style="top:19.0707%;margin-top:-8.5px;left:17.9025%;width:68px;"
      >
        <p class="g-pstyle2">TURKEY</p>
      </div>
      <div
        id="g-ai2-5"
        class="g-text g-aiAbs g-aiPointText"
        style="top:25.4336%;margin-top:-9.1px;left:46.8632%;width:57px;"
      >
        <p class="g-pstyle1">Tabriz</p>
      </div>
      <div
        id="g-ai2-6"
        class="g-text g-aiAbs g-aiPointText"
        style="top:37.3258%;margin-top:-10.2px;left:64.1492%;width:68px;"
      >
        <p class="g-pstyle3">Tehran</p>
      </div>
      <div
        id="g-ai2-7"
        class="g-text g-aiAbs g-aiPointText"
        style="top:37.1957%;margin-top:-8.5px;left:22.1449%;width:56px;"
      >
        <p class="g-pstyle2">SYRIA</p>
      </div>
      <div
        id="g-ai2-8"
        class="g-text g-aiAbs g-aiPointText"
        style="top:37.1957%;margin-top:-8.5px;left:35.3267%;width:51px;"
      >
        <p class="g-pstyle2">IRAQ</p>
      </div>
      <div
        id="g-ai2-9"
        class="g-text g-aiAbs g-aiPointText"
        style="top:49.4092%;margin-top:-10.2px;right:87.656%;width:83px;"
      >
        <p class="g-pstyle4">ISRAEL</p>
      </div>
      <div
        id="g-ai2-10"
        class="g-text g-aiAbs g-aiPointText"
        style="top:50.7547%;margin-top:-9.6px;left:32.1199%;margin-left:-35px;width:70px;"
      >
        <p class="g-pstyle5">950 km</p>
      </div>
      <div
        id="g-ai2-11"
        class="g-text g-aiAbs g-aiPointText"
        style="top:51.0758%;margin-top:-10.2px;left:69.2248%;width:65px;"
      >
        <p class="g-pstyle6">IRAN</p>
      </div>
      <div
        id="g-ai2-12"
        class="g-text g-aiAbs g-aiPointText"
        style="top:78.6541%;margin-top:-8.5px;left:32.2964%;width:105px;"
      >
        <p class="g-pstyle2">SAUDI ARABIA</p>
      </div>
    </div>
  {/if}
</div>
<!-- End ai2html - 2025-06-17 19:07 -->

<!-- Generated by ai2html v0.100.0 - 2025-06-17 19:07 -->
<!-- ai file: missilefacilities.ai -->
<style lang="scss">
  #g-missilefacilities-box,
  #g-missilefacilities-box .g-artboard {
    margin: 0 auto;
  }
  #g-missilefacilities-box p {
    margin: 0;
  }
  #g-missilefacilities-box .g-aiAbs {
    position: absolute;
  }
  #g-missilefacilities-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-missilefacilities-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-missilefacilities-xs {
    position: relative;
    overflow: hidden;
  }
  #g-missilefacilities-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 20px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(53, 53, 53);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-missilefacilities-xs .g-pstyle0 {
    height: 20px;
  }
  #g-missilefacilities-xs .g-pstyle1 {
    line-height: 11px;
    height: 11px;
    font-size: 11px;
    color: rgb(204, 204, 204);
  }
  #g-missilefacilities-xs .g-pstyle2 {
    line-height: 11px;
    height: 11px;
    font-size: 14px;
  }
  #g-missilefacilities-xs .g-pstyle3 {
    line-height: 11px;
    height: 11px;
    font-size: 12px;
    color: rgb(165, 15, 21);
  }
  #g-missilefacilities-xs .g-pstyle4 {
    font-weight: 700;
    line-height: 11px;
    height: 11px;
    font-size: 14px;
  }
  #g-missilefacilities-xs .g-pstyle5 {
    font-weight: 700;
    line-height: 11px;
    height: 11px;
    font-size: 14px;
    color: rgb(165, 15, 21);
  }
  #g-missilefacilities-sm {
    position: relative;
    overflow: hidden;
  }
  #g-missilefacilities-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 20px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(53, 53, 53);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-missilefacilities-sm .g-pstyle0 {
    height: 20px;
  }
  #g-missilefacilities-sm .g-pstyle1 {
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    color: rgb(128, 128, 128);
  }
  #g-missilefacilities-sm .g-pstyle2 {
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    color: rgb(204, 204, 204);
  }
  #g-missilefacilities-sm .g-pstyle3 {
    line-height: 16px;
    height: 16px;
    font-size: 14px;
  }
  #g-missilefacilities-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    color: rgb(165, 15, 21);
  }
  #g-missilefacilities-sm .g-pstyle5 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
  }
  #g-missilefacilities-sm .g-pstyle6 {
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    text-align: center;
    color: rgb(165, 15, 21);
  }
  #g-missilefacilities-md {
    position: relative;
    overflow: hidden;
  }
  #g-missilefacilities-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 20px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(53, 53, 53);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-missilefacilities-md .g-pstyle0 {
    height: 20px;
  }
  #g-missilefacilities-md .g-pstyle1 {
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(128, 128, 128);
  }
  #g-missilefacilities-md .g-pstyle2 {
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    color: rgb(204, 204, 204);
  }
  #g-missilefacilities-md .g-pstyle3 {
    line-height: 19px;
    height: 19px;
  }
  #g-missilefacilities-md .g-pstyle4 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    letter-spacing: 0.11em;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-missilefacilities-md .g-pstyle5 {
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
    color: rgb(165, 15, 21);
  }
  #g-missilefacilities-md .g-pstyle6 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    letter-spacing: 0.11em;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
